import React from "react";
import {
    Sprout,
    Dna,
    Feather,
    Droplets,
    Sparkles,
    Leaf,
    Shield,
    Star,
} from "lucide-react";

const ICONS = {
    sprout: Sprout,
    dna: Dna,
    feather: Feather,
    droplets: Droplets,
    sparkles: Sparkles,
    leaf: Leaf,
    shield: Shield,
    star: Star,
};

const DEFAULT_BENEFITS = [
    { icon: "sprout", title: "Concentrated Botanicals", text: "Rich natural extracts targeted to your scalp." },
    { icon: "dna", title: "Pure Biotin", text: "Rebuilds the keratin that makes hair strong." },
    { icon: "feather", title: "Non-Greasy Formula", text: "Fast-absorbing, perfect for Pakistani humidity." },
    { icon: "droplets", title: "Scalp Hydration", text: "Soothes dryness and inflammation deep down." },
];

export default function BenefitsSection({ product }) {
    const items = (product?.benefits?.length ? product.benefits : DEFAULT_BENEFITS).slice(0, 4);

    return (
        <section
            data-testid="benefits-section"
            id="benefits"
            className="py-16 sm:py-20 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mb-12">
                    <span className="text-gold-600 font-bold text-xs uppercase tracking-[0.25em] block mb-3">
                        Botanical Science Formula
                    </span>
                    <h2 className="font-serif text-4xl sm:text-5xl font-bold text-forest-800 leading-tight">
                        Why {product?.name || "Resham Drops"}{" "}
                        <span className="italic">actually</span> works.
                    </h2>
                    {product?.long_description && (
                        <p className="text-forest-900/70 mt-4 text-base sm:text-lg max-w-2xl">
                            {product.long_description}
                        </p>
                    )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                    {items.map((b, i) => {
                        const Icon = ICONS[(b.icon || "sparkles").toLowerCase()] || Sparkles;
                        return (
                            <div
                                key={i}
                                data-testid={`benefit-${i}`}
                                className="group bg-cream p-6 rounded-3xl border border-forest-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                            >
                                <div className="w-14 h-14 rounded-2xl bg-forest-50 text-forest-700 flex items-center justify-center mb-5 group-hover:bg-forest-800 group-hover:text-gold-400 transition-colors">
                                    <Icon className="w-7 h-7" />
                                </div>
                                <h3 className="font-serif font-bold text-xl text-forest-800 mb-2 leading-tight">
                                    {b.title}
                                </h3>
                                <p className="text-forest-900/70 text-sm leading-relaxed">
                                    {b.text}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
